module.exports = __webpack_public_path__ + "static/media/NPI.90c72982.png";